import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Wrong404 from "../404/Wrong404";
import routes from "./Route";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { getPortalNamespace, getLoginPath, storage } from "../utils/auth";

const AppContent = () => {
  const [data, setData] = useState(false);
  const [category, setCategory] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const handleRoute = async () => {
    const namespace = getPortalNamespace(location.pathname);
    if (!namespace) {
      setData(true);
      return;
    }

    const token = storage.get("token", namespace);
    if (!token) {
      navigate(getLoginPath(namespace));
      return;
    }

    let storedCategory = storage.get("permission", namespace);
    
    if (storedCategory) {
      const categoryArray = JSON.parse(storedCategory);
      
      // Special handling for subadmin which uses literal string instead of DB ObjectIds
      if (namespace === "subadmin" && categoryArray.includes("subadmin")) {
        setCategory(["subadmin"]);
        setData(true);
        return;
      }

      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/get-permission-name`, {
          permission: categoryArray,
        })
        .then((res) => {
          let perms = Array.isArray(res.data.data) ? res.data.data : [];
          if (namespace === "superadmin" && !perms.includes("super_admin")) {
            perms = [...perms, "super_admin"];
          }
          setCategory(perms);
          setData(true);
        })
        .catch((err) => {
          console.error(err);
          if (namespace === "superadmin") {
            setCategory(["super_admin"]);
          }
          setData(true);
        });
    } else {
      if (namespace === "superadmin") {
        setCategory(["super_admin"]);
      }
      setData(true);
    }
  };

  useEffect(() => {
    handleRoute();
  }, [location.pathname]);
  // console.log("category", category);

  const matchingObjects = routes.filter((obj) =>
    category.includes(obj.booleanValue)
  );

  return (
    <Routes>
      {data &&
        matchingObjects?.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            exact={route.exact}
            name={route.name}
            element={<route.element />}
          />
        ))}
      {data && <Route path="*" element={<Wrong404 />} />}
    </Routes>
  );
};
export default React.memo(AppContent);
